import api from '@api/apiServices';
import axiosInstance from '@api/axiosInstance';
import {
    Checkbox,
    FormControlLabel,
    Popover,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { hueToLabelColor } from '@utils/contactUtils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Label = ({ selected, label, addLabel, removeLabel }) => {
    return (
        <FormControlLabel
            labelPlacement="start"
            sx={{
                backgroundColor: hueToLabelColor(label.hue),
                borderRadius: them => them.shape.xs,
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
            control={
                <Checkbox
                    checked={selected}
                    onChange={e =>
                        e.target.checked ? addLabel(label) : removeLabel(label)
                    }
                />
            }
            label={
                <Typography
                    variant="bodyLarge"
                    color="textSecondary"
                    sx={{ py: 0.5, px: 1, flex: 1 }}
                >
                    {label.name}
                </Typography>
            }
        />
    );
};

const LabelFilter = ({
    filterField,
    addFilter,
    removeFilter,
    open,
    anchorEl,
    onClose,
    filters,
}) => {
    const { name, filterOptions } = filterField;

    const { t } = useTranslation();
    const [search, setSearch] = useState('');

    const currentLabels = filters?.[`${name}__${filterOptions[0]}`] || [];

    const { data: labels, isLoading } = useQuery({
        queryKey: ['contactsLabels'],
        queryFn: () => api.contacts.labels.get(),
    });

    const filteredLabels =
        labels?.filter(label =>
            label.name.toLowerCase().includes(search.toLowerCase()),
        ) || [];

    // if (isLoading) return <h2>Loading...</h2>;

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        p: 2,
                        width: 264,
                    },
                },
            }}
            disableRestoreFocus
        >
            <Stack spacing={2}>
                <Typography variant="labelLarge">
                    {t('Select label')}
                </Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    autoFocus
                    placeholder={t('Search labels')}
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <Stack spacing={1} maxHeight={300} overflow="auto">
                    {filteredLabels.map(label => (
                        <Label
                            key={label.name}
                            label={label}
                            selected={currentLabels.some(l => l === label.name)}
                            addLabel={label =>
                                addFilter(
                                    `${name}__${filterOptions[0]}`,
                                    label.name,
                                )
                            }
                            removeLabel={label =>
                                removeFilter(
                                    `${name}__${filterOptions[0]}`,
                                    label.name,
                                )
                            }
                        />
                    ))}
                </Stack>
            </Stack>
        </Popover>
    );
};

export default LabelFilter;
